module.exports = __webpack_public_path__ + "media/images/canada_flag-259890dcc467e7b2f6b7ccbffd182c9e.svg";